import { UserCohort } from 'owa-bizchat-types/lib/UserCohort';
import { getUserCohort } from 'owa-sidepane-bizchat-store';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import type { MailboxInfo } from 'owa-client-types';

/**
 * This function determines if the user is a Commercial Premium user.
 * This is used in contexts where certain experiments (like SUA Reading Pane Experiment) should only
 * be shown to Commercial Premium users, excluding Starter and MSA users.
 */
export function isUserCommercialPremium(mailboxInfo: MailboxInfo): boolean {
    const userCohort = getUserCohort(mailboxInfo);
    return !isConsumer(undefined /* smtpAddress */, mailboxInfo) && userCohort === UserCohort.BCAIS;
}
